// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemStyle } from "@insite/mobius/GridItem/GridItem";
import myAccountFilterSectionStyles from "@tps/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@tps/Overrides/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { hideElement } from "@tps/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            padding: 10px 15px;
            ${GridItemStyle} {
                padding: 10px;
                align-items: center;
            }
        `,
    }),
};

filterStyles.headingItem = {
    css: css`
        ${hideElement}
    `,
};

filterStyles.fromGridItem = filterStyles.toGridItem = {
    width: [12, 6, 3, 3, 3],
    css: css`
        > div {
            width: 100%;
            display: flex;
            padding-top: 2px;
        }
    `,
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.buttonsItem = {
    width: [12, 6, 8, 12, 8],
    css: css`
        &&& {
            justify-content: flex-end;
            align-items: flex-end;
        }
    `,
};

filterStyles.onlyOpenGridItem = {
    width: [12, 6, 4, 3, 4],
    align: "middle",
    css: css`
        > div {
            margin-top: 24px;
            ${xScreen("lte", "md")} {
                margin-top: 0;
            }
        }
        padding-top: 0;
    `,
};

filterStyles.shipToGridItem = {
    width: [12, 6, 6, 6, 4],
};

filterStyles.invoiceNumberGridItem = {
    width: [12, 6, 3, 3, 3],
};

filterStyles.orderNumberGridItem = {
    width: [12, 6, 3, 3, 3],
};

filterStyles.orderTypeGridItem = {
    width: [12, 6, 3, 3, 2],
};

filterStyles.orderedByGridItem = {
    width: [12, 6, 3, 3, 2],
};

filterStyles.poNumberGridItem = {
    width: [12, 6, 3, 3, 2],
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
